import { IClient } from "@wingspanhq/users/dist/lib/interfaces";

export const selectorPaymentMethod = (client: IClient, cardId: string) => {
  return (client.profile.savedPaymentMethods || []).find(
    paymentMethod => paymentMethod.paymentMethodId === cardId
  );
};
